import * as Sentry from '@sentry/browser';
import { OV_ALERT, TEXT } from '../config/constants';

var errorHandler = function errorHandler(exception, context) {
  var _window = window,
      dispatchEvent = _window.dispatchEvent;
  var event = new CustomEvent(OV_ALERT, {
    detail: TEXT.alert
  });
  dispatchEvent(event);
  console.error(exception, context);

  if (Sentry === undefined || exception === undefined) {
    return;
  }

  Sentry.captureException(exception);
};

export default errorHandler;